import { VoiceApiEndpoints } from "../apiEndpoints";
import { fetchData } from "../apiHelpers";
import { buildVoiceUrl } from "../voiceApi";
import { VoiceAgent } from "../agent.type";

export async function getVoiceAgents(): Promise<VoiceAgent[]> {
  const url = buildVoiceUrl(VoiceApiEndpoints.agents);
  return fetchData<VoiceAgent[]>(url, { method: "GET" });
}
